
export default {
  namespaced: true,
  facility_category: {
    title: "Facility Category | Facility Categories",
    name: "Name",
    description: "Description",
  },
};
